import Api from "./Api";
import AuthManager from "./AuthManager";
import { PubEvent, EventType } from "./data/Responses";
import CreateEventData from "./data/CreateEventData";

export default class EventCreationViewModel {
    api: Api;
    authManager: AuthManager;
    public handleError: (error: any) => void;

    public createEventData = new CreateEventData("", "", new Date(), new Date(), "", null, false, EventType.open, false);

    constructor(authManager: AuthManager, api: Api, handleError: (error: any) => void) {
        this.api = api;
        this.authManager = authManager;
        this.handleError = handleError;
    }

    reset() {
        const now = new Date();
        const oneDay = 24 * 60 * 60 * 1000; // number of milliseconds in a day
        const oneHour = 60 * 60 * 1000; // number of milliseconds in a day

        const start = new Date(now.getTime() + oneDay + oneHour);

        start.setHours(start.getHours() + Math.round(start.getMinutes() / 60));
        start.setMinutes(0, 0, 0); // Resets also seconds and milliseconds

        const end = new Date(now.getTime() + oneDay + 3 * oneHour);

        end.setHours(end.getHours() + Math.round(end.getMinutes() / 60));
        end.setMinutes(0, 0, 0); // Resets also seconds and milliseconds

        this.createEventData = new CreateEventData("", "", start, end, "", null, false, EventType.open, false);
    }

    setReasonableEndDate() {
        const oneHour = 60 * 60 * 1000; // number of milliseconds in a day
        const end = new Date(this.createEventData.startDateInternal.getTime() + 3 * oneHour);

        end.setHours(end.getHours() + Math.round(end.getMinutes() / 60));
        end.setMinutes(0, 0, 0); // Resets also seconds and milliseconds

        this.createEventData.endDateInternal = end;
    }

    setEventData(event: PubEvent) {
        const date = new Date(event.time); // convert epoch to milliseconds and create a new Date object
        this.createEventData.endDateInternal = date;

        const endDate = event.endTime == null ? new Date() : new Date(event.endTime); // convert epoch to milliseconds and create a new Date object
        this.createEventData = new CreateEventData(event.name, event.location, date, endDate, event.description, event, event.endTime != null, event.type, event.cancelled);
    }

    async create() {
        try {
            const event: PubEvent = await this.api.createEvent(this.createEventData.toNewEventRequest());
            return event.id; // Return the ID of the created event
        } catch (error) {
            this.handleError(error);
            throw error; // Rethrow the error to the caller
        }
    }

    async update() {
        if (this.createEventData.event == null) {
            return;
        }

        try {
            const event: PubEvent = await this.api.updateEvent(this.createEventData.toUpdateEventRequest());
            this.setEventData(event);
            return event;
        } catch (error) {
            this.handleError(error);
            throw error; // Rethrow the error to the caller
        }
    }
}
